import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import firebaseApp from "./firebaseConfigAndInit"; // import firebase from "firebase/app"; -- This was the Programming with Erik way
// import "firebase/analytics";  -- Holding off on importing analytics as it *might* be throwing an error, and I don't want to troubleshoot this now

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

Vue.prototype.$axios = axios; //Allows axios to be accessed from anywhere in the app
Vue.config.productionTip = false;

//This was from the Programming with Erik Youtube Video -- https://youtu.be/XtbYBoKb2zY?t=2220
let vueApp;

// eslint-disable-next-line no-unused-vars
firebaseApp.auth().onAuthStateChanged(user => {
  // console.log(user);
  if (!vueApp) {
    //This boots up the complete app when its done
    vueApp = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});

// firebase.analytics(); -- Holding off on importing analytics as it *might* be throwing an error, and I don't want to troubleshoot this now
